import { DatePipe } from '@angular/common';
import { CdkConnectedOverlay, CdkOverlayOrigin, ConnectionPositionPair, OverlayModule } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotificationsInboxService } from 'src/app/internal/views/monitoramento/services/notifications-inbox.service';

@Component({
  selector: 'app-notifications-bell',
  templateUrl: './notifications-bell.component.html',
  styleUrls: ['./notifications-bell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, MatIconModule, MatTooltipModule, OverlayModule, CdkConnectedOverlay, CdkOverlayOrigin],
})
export class NotificationsBellComponent {
  readonly inbox = inject(NotificationsInboxService);

  readonly isOpen = signal(false);
  readonly skeletonRows = [1];

  readonly overlayPositions: ConnectionPositionPair[] = [
    new ConnectionPositionPair({ originX: 'end', originY: 'bottom' }, { overlayX: 'end', overlayY: 'top' }, 0, 8),
    new ConnectionPositionPair({ originX: 'end', originY: 'top' }, { overlayX: 'end', overlayY: 'bottom' }, 0, -8),
  ];

  toggle(): void {
    const next = !this.isOpen();
    this.isOpen.set(next);
    if (next) {
      this.inbox.requestNotificationPermission(true);
      this.inbox.loadInbox();
    }
  }

  close(): void {
    this.isOpen.set(false);
  }

  badgeLabel(): string {
    const count = this.inbox.unreadCount();
    return count > 99 ? '99+' : String(count);
  }

  ariaLabel(): string {
    const count = this.inbox.unreadCount();
    if (!count) return 'Notificações';
    return `Notificações, ${count} não lidas`;
  }

  markRead(id: string, event: Event): void {
    event.stopPropagation();
    this.inbox.markRead(id);
  }

  markAllRead(event: Event): void {
    event.stopPropagation();
    this.inbox.markAllRead();
  }
}
